import './vendors.js';
import './scripts/pandora-auth';
import './scripts/pandora-auth-client';
import './scripts/pandora-auth-session-client';

export default 'mx.auth';